export default __webpack_public_path__ + "static/amj_back-84eae88d49c3e4387eb5c31308c35c4d.webp";